import React, { useEffect } from 'react';
import { FileText, AlertCircle, CheckCircle } from 'lucide-react';

const Terms: React.FC = () => {
  // Set page title and canonical URL
  useEffect(() => {
    document.title = 'Điều Khoản Sử Dụng - VMon Cloud';
    
    // Set canonical URL
    const existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
    }
    
    const canonical = document.createElement('link');
    canonical.rel = 'canonical';
    canonical.href = 'https://vmon.vn/dieu-khoan-su-dung';
    document.head.appendChild(canonical);
    
    return () => {
      if (canonical.parentNode) {
        canonical.parentNode.removeChild(canonical);
      }
      document.title = 'VMon Cloud - Dịch vụ VPS và Hosting chất lượng cao';
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-gray-700 to-gray-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="flex items-center justify-center mb-4">
              <FileText className="h-8 w-8 mr-2" />
              <span className="text-2xl font-semibold">Điều Khoản Sử Dụng</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Điều Khoản & Điều Kiện
            </h1>
            <p className="text-xl mb-8 max-w-3xl mx-auto">
              Vui lòng đọc kỹ các điều khoản và điều kiện sử dụng dịch vụ của VMON
            </p>
            <p className="text-sm text-gray-300">Cập nhật lần cuối: 01/02/2023</p>
          </div>
        </div>
      </section>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Introduction */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <div className="flex items-center mb-4">
            <AlertCircle className="h-6 w-6 text-blue-600 mr-2" />
            <h2 className="text-2xl font-bold text-gray-900">Giới Thiệu</h2>
          </div>
          <p className="text-gray-600 leading-relaxed">
            Chào mừng bạn đến với VMON. Bằng việc sử dụng dịch vụ của chúng tôi, bạn đồng ý tuân thủ 
            và bị ràng buộc bởi các điều khoản và điều kiện sau đây. Nếu bạn không đồng ý với bất kỳ 
            phần nào của các điều khoản này, vui lòng không sử dụng dịch vụ của chúng tôi.
          </p>
        </div>

        {/* Service Terms */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <div className="flex items-center mb-4">
            <CheckCircle className="h-6 w-6 text-green-600 mr-2" />
            <h2 className="text-2xl font-bold text-gray-900">Trách Nhiệm Của Khách Hàng</h2>
          </div>
          <div className="space-y-4 text-gray-600">
            <p>
              Người sử dụng (bên mua) phải tự chịu trách nhiệm và đảm bảo với chúng tôi (bên cung cấp) trong việc sử dụng Máy chủ của mình trên hệ thống vào những mục đích hợp pháp. Đặc biệt trong những trường hợp sau:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Không dùng server vào bất kì mục đích/hình thức nào vi phạm pháp luật Việt Nam, đặc biệt về vấn đề chính trị, tôn giáo, bản quyền... Đồng thời có trách nhiệm kiểm soát và ngăn cấm người khác làm điều đó trên máy chủ của mình.</li>
              <li>Bất kì loại dữ liệu nào mang tính bất hợp pháp, đe dọa, lừa dối, thù hằn, xuyên tạc, nói xấu, tục tĩu, khiêu dâm, xúc phạm...hay các hình thức bị ngăn cấm khác dưới bất kì cách thức nào.</li>
              <li>Bất kì loại dữ liệu nào mà cấu thành hoặc khuyến khích các hình thức phạm tội; hoặc các dữ liệu mang tính vi phạm luật sáng chế, nhãn hiệu, quyền thiết kế, bản quyền hay bất kì quyền sỡ hữu trí tuệ hoặc các quyền hạn của bất kì cá nhân nào.</li>
              <li>Không sử dụng dịch vụ của VMon Cloud cung cấp cho mục đích: tổ chức đánh bạc, cá độ, lô đề, hack, tấn công phá hoại (DDoS), lừa đảo, Spam Mail.</li>
              <li>Khách hàng tự bảo mật an ninh, an toàn các thông tin liên quan tới tài chính trên máy chủ (Ví bitcoin, Paypal, các tài khoản có giá trị...). VMon Cloud chỉ cung cấp máy chủ và đảm bảo máy chủ hoạt động ổn định.</li>
              <li>Người sử dụng giữ một cách an toàn các thông tin nhận biết, mật khẩu hay những thông tin mật khác liên quan đến tài khoản của mình và lập tức thông báo cho chúng tôi khi phát hiện các hình thức truy cập trái phép.</li>
              <li>Người sử dụng không dùng các chương trình có khả năng làm tắc nghẽn hoặc đình trệ hệ thống, như gây cạn kiệt tài nguyên hệ thống, làm quá tải bộ vi xử lý và bộ nhớ (HACK, DoS, DDoS, Malwares, Virus, VPN, Mining Coin).</li>
            </ul>
            <p>
              Người sử dụng được dùng tài nguyên host theo đúng thông số tương ứng gói dịch vụ đã đăng ký. Tuy nhiên, nhằm đảm bảo chất lượng cho máy chủ phục vụ, hệ thống sẽ tự động phát hiện các Máy chủ, Host có dấu hiệu lạm dụng tài nguyên hệ thống quá mức (thường xuyên sử dụng CPU ở mức cao, chiếm dụng băng thông lớn...) và đưa ra các phương án giải quyết phù hợp.
            </p>
          </div>
        </div>

        {/* Provider Responsibilities */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Quyền và Trách Nhiệm Của Bên Cung Cấp</h2>
          <div className="space-y-4 text-gray-600">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">2.1 Bảo mật thông tin</h3>
              <p>
                Bảo mật thông tin của khách hàng và những dữ liệu khách hàng cung cấp cho VMon Cloud. Không được phép cung cấp thông tin cho bất kỳ bên thứ ba nào ngoại trừ khi có yêu cầu của các cơ quan chức năng có thẩm quyền hoặc được sự chấp thuận của khách hàng.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">2.2 Bảo đảm dữ liệu</h3>
              <p>
                Trong khi dùng các biện pháp có thể và nỗ lực nhằm bảo đảm sự toàn vẹn và an toàn cho server, chúng tôi không chịu trách nhiệm bồi thường dữ liệu của người sử dụng lưu trữ tại máy chủ trong trường hợp hệ thống server bị phá hoại từ những người dùng bất hợp pháp, các hacker hoặc do các sự cố bất khả kháng: thiên tai, hoả hoạn, hệ thống máy chủ hỏng vật lý phần cứng.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">2.3 Tạm ngưng dịch vụ</h3>
              <p>
                Chúng tôi sẽ tạm ngưng dịch vụ mà không cần thông báo trước vì lý do vi phạm từ phía người sử dụng ở các mục đã nêu trên. Trường hợp muốn mở lại, khách hàng phải cam kết không tái diễn vi phạm. Trong trường hợp xấu nhất, chúng tôi sẽ buộc phải cắt dịch vụ vĩnh viễn mà không hoàn trả lại phí.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">2.4 Thông báo hết hạn</h3>
              <p>
                Trước khi dịch vụ hết hạn, hệ thống sẽ liên tục gửi Email để thông báo tới Khách hàng. Nếu khách hàng không gia hạn, hệ thống sẽ tự động hủy dịch vụ trong vòng 3 ngày và <strong>không thể khôi phục lại</strong>. Chúng tôi không chịu trách nhiệm trong trường hợp Khách hàng không theo dõi Email/SMS, hoặc cung cấp thông tin không đúng, dẫn đến hệ thống không gửi được thông báo.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">2.5 Sao lưu dữ liệu</h3>
              <p>
                Chúng tôi sao lưu dữ liệu hàng tuần, tuy nhiên việc sao lưu này chỉ phục vụ cho mục đích quản lý của chúng tôi. Nếu người sử dụng yêu cầu cung cấp, chúng tôi sẽ gửi những bản sao lưu nhưng chúng tôi không chịu trách nhiệm về những sự cố xảy ra cho các dữ liệu này. Vì vậy, chúng tôi khuyến cáo người sử dụng nên sao lưu dữ liệu thường xuyên về máy tính hoặc trên các thiết bị lưu trữ của mình để tránh những sự cố đáng tiếc xảy ra.
              </p>
            </div>
          </div>
        </div>

        {/* Payment Terms */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Quy Định Về Thanh Toán</h2>
          <div className="space-y-4 text-gray-600">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">3.1 Cam kết hoàn tiền</h3>
              <p>
                Chúng tôi cam kết hoàn tiền 100% vào tài khoản trên website của Khách hàng trong vòng 1 tuần khởi tạo dịch vụ, nếu như dịch vụ không đúng cam kết. Cam kết ở đây được hiểu là những thông tin về Máy chủ đã được ghi rõ ràng khi khởi tạo.
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 mt-2">
                <li>Đối với dịch vụ Máy chủ ảo (VPS) được chia sẻ từ cụm máy chủ vật lý, khách hàng có quyền sử dụng tối đa tài nguyên tới mức được công bố (nhưng không vi phạm chính sách).</li>
                <li>Đối với dịch vụ Máy chủ vật lý (Dedicated Server). Khách hàng toàn quyền quản trị máy chủ mà mình đã thuê và khách hàng có thể sử dụng tải phần cứng tùy ý vì sẽ không ảnh hưởng tới khách hàng khác.</li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">3.2 Đơn vị tiền tệ</h3>
              <p>
                Sử dụng duy nhất VNĐ cho thanh toán các dịch vụ. Các dịch vụ cung cấp đều là dịch vụ trả trước. Bên bán có quyền từ chối các khoản thanh toán liên quan tới gian lận.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">3.3 Hoàn tiền dư</h3>
              <p>
                Các khoản dư của khách hàng trong tài khoản tại website vmon.vn khi không còn nhu cầu sử dụng sẽ được hoàn lại tài khoản khi Khách hàng yêu cầu. Các khoản hoàn lại chỉ tính dựa trên Tài khoản chính. Sau khi tiếp nhận yêu cầu của Khách hàng, bộ phận tài chính sẽ kiểm tra và thực hiện chuyển hoàn trong tối đa 30 ngày làm việc. Số dư tối thiểu để yêu cầu hoàn tiền là 50.000 VNĐ (Năm mươi nghìn Đồng), phí chuyển khoản Ngân hàng bên bán sẽ chịu.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">3.4 Hóa đơn VAT</h3>
              <p>
                Nếu cần xuất hóa đơn VAT, quý khách vui lòng liên hệ với nhân viên chăm sóc khách hàng.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">3.5 Nội dung thanh toán</h3>
              <p>
                Quý khách hàng vui lòng ghi rõ nội dung thanh toán khi chuyển tiền vào tài khoản của VMon Cloud. Nội dung gửi kèm khi chuyển tiền chỉ cần số hóa đơn.
              </p>
            </div>
          </div>
        </div>

        {/* Service Suspension and Termination */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Tạm Ngừng và Chấm Dứt Sử Dụng Dịch Vụ</h2>
          <div className="space-y-4 text-gray-600">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">4.1 Chấm dứt dịch vụ</h3>
              <p>
                Dịch vụ do VMon Cloud cung cấp sẽ tự động chấm dứt/tạm ngừng theo thỏa thuận của hai bên hoặc đến thời điểm hết hiệu lực hợp đồng hợp tác dịch vụ.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">4.2 Quyền tạm dừng</h3>
              <p>
                VMon Cloud có quyền tạm dừng thực hiện hợp đồng hoặc đơn phương chấm dứt hợp đồng dịch vụ trong các trường hợp sau đây:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4 mt-2">
                <li>Khách hàng có hành vi vi phạm quy định của Điều khoản sử dụng dịch vụ trong quá trình sử dụng sản phẩm, dịch vụ của chúng tôi.</li>
                <li>Khách hàng không hợp tác và không đáp ứng phối hợp bổ sung tài liệu cần thiết.</li>
                <li>Khách hàng không thực hiện việc gia hạn và thanh toán các khoản phí quá hạn sử dụng dịch vụ cho VMon Cloud trong thời hạn 3 ngày, kể từ thời điểm hết hạn sử dụng dịch vụ.</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Customer Information Privacy Policy */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Chính Sách Bảo Mật Thông Tin Khách Hàng</h2>
          <div className="space-y-4 text-gray-600">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">5.1 Thông tin khách hàng</h3>
              <p>
                VMon Cloud tôn trọng sự riêng tư và quản lý nghiêm túc thông tin của khách hàng.
              </p>
              <p className="mt-2">
                Thông tin khách hàng gồm có tên, địa chỉ email, số điện thoại, địa chỉ liên hệ và các thông tin cá nhân khác do khách hàng chủ động cung cấp hoặc được VMon Cloud thu thập bằng các phương thức hợp lệ khác.
              </p>
              <p className="mt-2">
                Thông tin khách hàng không bao gồm dữ liệu về website và các dịch vụ khác của khách hàng đang sử dụng hoặc lưu trữ trên máy chủ cung cấp dịch vụ của VMon Cloud.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">5.2 Dữ liệu khách hàng</h3>
              <p>
                Dữ liệu của khách hàng gồm có mã nguồn website, cơ sở dữ liệu, cấu hình dịch vụ và các dữ liệu khác do khách hàng cung cấp, tự quản lý và lưu trữ trên các máy chủ cung cấp dịch vụ của VMon Cloud.
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">5.3 Thu thập thông tin khách hàng</h3>
              <p>
                Khách hàng có thể liên hệ với VMon Cloud hoặc truy cập các website trong hệ thống quản lý của VMon Cloud để phục vụ nhu cầu tìm hiểu thông tin về dịch vụ và có thể lựa chọn không cung cấp các thông tin cá nhân.
              </p>
              <p className="mt-2">
                Khi đăng ký và sử dụng dịch vụ của VMon Cloud, khách hàng phải cung cấp các thông tin liên hệ đầy đủ và chính xác theo yêu cầu của Quy định sử dụng dịch vụ.
              </p>
            </div>
          </div>
        </div>

        {/* Prohibited Activities */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Hoạt Động Bị Cấm</h2>
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
            <p className="text-red-700 font-medium">
              Các hoạt động sau đây bị nghiêm cấm và có thể dẫn đến việc khóa tài khoản:
            </p>
          </div>
          <div className="space-y-2 text-gray-600">
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Gửi spam email hoặc tin nhắn</li>
              <li>Tấn công mạng, hack, phishing</li>
              <li>Lưu trữ nội dung bất hợp pháp</li>
              <li>Vi phạm bản quyền</li>
              <li>Khai thác tiền điện tử (mining)</li>
              <li>Proxy/VPN không được phép</li>
              <li>Chia sẻ tài khoản cho nhiều người</li>
            </ul>
          </div>
        </div>

        {/* Termination */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Chấm Dứt Dịch Vụ</h2>
          <div className="space-y-4 text-gray-600">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">9. Hủy Dịch Vụ</h3>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>Khách hàng có thể hủy dịch vụ bất kỳ lúc nào</li>
                <li>Thông báo hủy trước 7 ngày qua email</li>
                <li>Không hoàn tiền cho thời gian còn lại</li>
                <li>Dữ liệu sẽ bị xóa sau 7 ngày kể từ ngày hết hạn</li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">10. Khóa Tài Khoản</h3>
              <ul className="list-disc list-inside space-y-1 ml-4">
                <li>VMON có quyền khóa tài khoản vi phạm điều khoản</li>
                <li>Thông báo trước khi khóa (trừ trường hợp khẩn cấp)</li>
                <li>Khách hàng có quyền khiếu nại trong 30 ngày</li>
                <li>Hoàn tiền theo tỷ lệ thời gian chưa sử dụng (nếu có)</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Force Majeure */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Bất Khả Kháng</h2>
          <div className="space-y-4 text-gray-600">
            <p>
              6.1 Nếu bất kỳ sự kiện nào như thiên tai, dịch họa, lũ lụt, hoả hoạn, động đất, đình công, can thiệp của Nhà nước hay bất cứ sự kiện nào khác xảy ra ngoài tầm kiểm soát của bất kỳ bên nào và không thể lường trước được, thì Bên bị ảnh hưởng bởi sự kiện bất khả kháng sẽ được tạm hoãn thực hiện nghĩa vụ trong hợp đồng này, với điều kiện là Bên bị ảnh hưởng đó đã áp dụng mọi biện pháp cần thiết để ngăn ngừa, hạn chế hoặc khắc phục hậu quả của sự kiện đó.
            </p>
            <p>
              6.2 Bên bị ảnh hưởng bởi sự kiện bất khả kháng có nghĩa vụ thông báo cho bên còn lại ngay khi có thể. Trường hợp sự kiện bất khả kháng xảy ra, các bên được miễn trách nhiệm bồi thường thiệt hại.
            </p>
            <p>
              6.3 Nếu sự kiện bất khả kháng không chấm dứt trong vòng 30 (ba mươi) ngày làm việc hoặc một khoảng thời gian lâu hơn và vẫn tiếp tục ảnh hưởng đến việc thực hiện Hợp đồng hợp tác dịch vụ thì bên nào cũng có quyền đơn phương chấm dứt Hợp đồng và thông báo cho bên còn lại bằng văn bản trong vòng 10 (mười) ngày làm việc kể từ ngày dự định chấm dứt.
            </p>
          </div>
        </div>

        {/* Policy Changes */}
        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Thay Đổi Chính Sách</h2>
          <div className="space-y-4 text-gray-600">
            <p>
              Điều khoản sử dụng dịch sẽ được thay đổi và cập nhật cho phù hợp với từng thời điểm và các loại hình dịch vụ. Khách hàng có trách nhiệm thường xuyên theo dõi email hoặc văn bản này để đảm bảo luôn thực hiện đúng theo các điều khoản quy định.
            </p>
            <p>
              Khi cập nhật nội dung chính sách này, VMon Cloud sẽ chỉnh sửa lại thời gian trong phần ghi chú "cập nhật lần cuối" trên website.
            </p>
            <p className="font-semibold text-blue-600">
              Cập nhật lần cuối ngày 01/02/2023
            </p>
          </div>
        </div>

        {/* Contact */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-3">Liên Hệ</h3>
          <p className="text-gray-600 mb-4">
            Nếu bạn có bất kỳ câu hỏi nào về các điều khoản này, vui lòng liên hệ với chúng tôi:
          </p>
          <div className="space-y-2 text-gray-600">
            <p><strong>Email:</strong> support@vmon.vn</p>
            <p><strong>Điện thoại:</strong> 0966.805.315</p>
            <p><strong>Địa chỉ:</strong> Tầng 6, Tòa nhà G3, VINHOMES GREENBAY, SỐ 7, ĐCT08, Mễ Trì, Nam Từ Liêm, Hà Nội</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;